import React, {useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {format} from 'date-fns';
import {useForm, Controller} from 'react-hook-form';
import {downloadCreditMemoReport} from '@ibibo/myaccount-reducer';
import TextInput from '../../../../common/Form/TextInput/TextInput';
import DateRangePicker from '../../../../common/Form/DateRangePicker/DateRangePicker';
import {FormContainer, DownloadButton} from './CreditMemo.styles';
import Info from '../Info/Info';
const CreditMemo = ({creditMemo, dateObject, setCreditMemoData, creditMemoData}) => {
  const host = `${__ENV_CONFIG__.MYPARTNER}`;
  const dispatch = useDispatch();
  const {primaryText, subText = [], show_form: showForm} = creditMemo;

  const [isValidForm, setIsValidForm] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    control,
    reset,
    watch,
    formState: {isDirty, isValid},
  } = useForm({
    defaultValues: {
      credit_memo_number: '',
      credit_memo_date: format(new Date(), 'yyyy-MM-dd'),
      flights_commission: '',
      hotels_commission: '',
      wallet_commission: '',
    },
  });

  useEffect(() => {
    const subscription = watch((value, {name, type}) => {
      const objToCopy = creditMemoData;
      objToCopy[name] = value[name];
      setCreditMemoData({...objToCopy});
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    let flag = true;
    for (const i in creditMemoData) {
      if (showForm) {
        if (creditMemoData[i] == '') {
          flag = false;
        }
      } else {
        if (i != 'flights_commission' && i != 'hotels_commission' && i != 'wallet_commission') {
          if (creditMemoData[i] == '') {
            flag = false;
          }
        }
      }
    }
    setIsValidForm(flag);
  }, [creditMemoData]);

  const handleDownloadCreditMemo = () => {
    const values = getValues();
    let url = `${host}/commission/download-credit-memo?credit_memo_number=${values?.credit_memo_number}&start_date=${dateObject?.start_date}&end_date=${dateObject?.end_date}&credit_memo_date=${values?.credit_memo_date}`;
    if (showForm) {
      url = `${url}&flights_commission=${values?.flights_commission}&hotels_commission=${values?.hotels_commission}&wallet_commission=${values?.wallet_commission}`;
    }
    window.open(url, '_blank');
  };

  return (
    <>
      {primaryText && <h3 className="latoBlack20">{primaryText}</h3>}
      {subText?.length > 0 && (
        <>
          <div className="mt10"></div>
          {subText?.map((item, idx) => {
            return (
              <>
                <Info
                  text={item?.secondaryText}
                  heading={item?.primaryText}
                  inline={true}
                  width="auto"
                />
              </>
            );
          })}
        </>
      )}
      <div className="mt10"></div>
      <form onSubmit={handleSubmit(handleDownloadCreditMemo)}>
        <FormContainer>
          <div className="row">
            <div>
              <Controller
                control={control}
                name={'credit_memo_number'}
                render={({field: {onChange, onBlur, value}}) => (
                  <TextInput
                    onTextChange={onChange}
                    labelText={'Enter Credit Memo Number'}
                    type="text"
                    regexPattern={/[ &@#$%^*()_+=]/g}
                    maxLength={16}
                  />
                )}
              />
            </div>
            <Controller
              control={control}
              rules={{required: true}}
              name={'credit_memo_date'}
              render={({field: {onChange, onBlur, value}}) => (
                <DateRangePicker
                  ref={null}
                  //singleDate={dateTruthFlag}
                  startLabel={'Credit Memo Date'}
                  startValue={value}
                  changeHandler={onChange}
                  //ref={null}
                  //hidePreviousDate={dateTruthFlag}
                  endDate={dateObject?.end_date}
                  readOnly={false}
                  isMandatory={false}
                />
              )}
            />
          </div>
          {showForm && (
            <div className="row">
              <Controller
                control={control}
                name={'flights_commission'}
                render={({field: {onChange, onBlur, value}}) => (
                  <TextInput
                    onTextChange={onChange}
                    labelText={'Commission Earned for Flights'}
                    type="text"
                    regexPattern={/[^0-9.]/g}
                    isValidator={true}
                  />
                )}
              />
              <Controller
                control={control}
                name={'hotels_commission'}
                render={({field: {onChange, onBlur, value}}) => (
                  <TextInput
                    onTextChange={onChange}
                    labelText={'Commission Earned for Hotels'}
                    type="text"
                    regexPattern={/[^0-9.]/g}
                    isValidator={true}
                  />
                )}
              />
              <Controller
                control={control}
                name={'wallet_commission'}
                render={({field: {onChange, onBlur, value}}) => (
                  <TextInput
                    onTextChange={onChange}
                    labelText={'Commission Earned for My Wallet'}
                    type="text"
                    regexPattern={/[^0-9.]/g}
                    isValidator={true}
                  />
                )}
              />
            </div>
          )}
        </FormContainer>
        <div className="mt10"></div>
        <DownloadButton isActive={isValidForm} disabled={!isValidForm}>
          Download Credit Memo
        </DownloadButton>
      </form>
    </>
  );
};

export default CreditMemo;
